import script from "./FolderPicker.vue?vue&type=script&setup=true&lang=js"
export * from "./FolderPicker.vue?vue&type=script&setup=true&lang=js"

import "./FolderPicker.vue?vue&type=style&index=0&id=0d5f2bec&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d5f2bec"]])

export default __exports__